import request from '../libs/request';

const res = 'Application';

export default {
  submit(applicationType, model) {
    if (applicationType.isCustom) {
      return request({
        url: `api/${res}/submit`,
        method: 'post',
        data: {
          applicationTypeID: applicationType.id,
          model
        }
      });
    } else {
      return request({
        url: `api/${applicationType.model}/submit`,
        method: 'post',
        data: model
      });
    }
  },
  save(applicationType, model) {
    if (applicationType.isCustom) {
      return request({
        url: `api/${res}/save`,
        method: 'post',
        data: {
          applicationTypeID: applicationType.id,
          model
        }
      });
    } else {
      return request({
        url: `api/${applicationType.model}/save`,
        method: 'post',
        data: model
      });
    }
  },
  cancel(id) {
    return request({
      url: `api/${res}/cancel`,
      method: 'post',
      data: {
        id
      }
    });
  }
};
